import { render, staticRenderFns } from "./CarrouselDefault.vue?vue&type=template&id=3e67c666"
import script from "./CarrouselDefault.vue?vue&type=script&lang=js"
export * from "./CarrouselDefault.vue?vue&type=script&lang=js"
import style0 from "./CarrouselDefault.vue?vue&type=style&index=0&id=3e67c666&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports